import { render } from "./allimages.vue?vue&type=template&id=b7a67f70"
import script from "./allimages.vue?vue&type=script&lang=js"
export * from "./allimages.vue?vue&type=script&lang=js"
script.render = render

export default script